import React from 'react';
import { userConnectionPropTypes } from '../../../../sharedPropTypes';
import { func } from 'prop-types';
import SuggestionCardBase from '../SuggestionCardBase';
import FollowButton from '../../../buttons/FollowButton';
import { fullName, cityRegion } from '../../../../utils/text_formatters';

const UserSuggestionCard = ({ onClearClick, userConnection }) => {
  return (
    <SuggestionCardBase
      title={fullName(userConnection.user)}
      subtext={cityRegion(userConnection.user.location)}
      imgSrc={userConnection.user.profilePhoto?.href}
      button={<FollowButton userConnection={userConnection} />}
      onClearClick={onClearClick}
    />
  );
};

UserSuggestionCard.propTypes = {
  userConnection: userConnectionPropTypes.isRequired,
  onClearClick: func.isRequired
};

export default UserSuggestionCard;
